//Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import jsFileDownload from 'js-file-download';
//Componentes material
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
//Ícones
import MailOutlineIcon from '@material-ui/icons/MailOutline';
//Componentes
import VitalizePaper from '../components/VitalizePaper';
import ResultadoSecao from '../components/resultado/ResultadoSecao';
import Layout from './Layout';
import VitalizeFab from '../components/VitalizeFab';
import LoadingButton from '../components/LoadingButton';
import ConfirmDialog from '../components/ConfirmDialog';
//Controllers
import AvaliacaoController from '../controllers/AvaliacaoController';
import PermissaoController from '../controllers/PermissaoController';
//Models
import formatarIdade from '../utils/formatarIdade';
//Estilos
import ResultadoStyle from '../styles/ResultadoStyle';
//Utils
import { converterNumero } from '../utils/validacao';

/**
 * @typedef {Object} Parametros
 * @property {Number} cliente Identificação do cliente
 * @property {Number} questionario Identificação do questionário
 * @property {Number} quantidade Quantidade de avaliações a serem exibidas
 * @property {Array<Number>} avaliacoes Lista de identificação das avaliações a serem impressas
 */

class ResultadoShowPage extends Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleDownloadPDFClick = this.handleDownloadPDFClick.bind(this);
        this.handleEnviarEmailClick = this.handleEnviarEmailClick.bind(this);
        this.handleConfimClose = this.handleConfimClose.bind(this);
        //Controllers
        this.avaliacaoController = new AvaliacaoController();
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            carregando: true,
            erro: '',
            avaliacoes: [],
            processando: false,
            confirmarEnvio: false
        };
    }

    async componentDidMount() {
        //Inicializando variáveis
        const parametros = this.obterParametros();
        let avaliacoes = [];
        //Valida os parâmetros
        let erro = await this.validarParametros(parametros);

        //Se não houver erro, consulta a API
        if (!erro) {
            avaliacoes = await this.getAvaliacao(parametros);
            if (avaliacoes.length === 0) {
                erro = 'Nenhuma avaliação foi encontrada';
            }
        }
        this.setState({ avaliacoes, erro, carregando: false });
    }

    /**
     * Valida os parâmetros recebidos e retorna a mensagem de erro
     * @param {Parametros} parametros Parâmetros recebidos
     * @returns {String} Retorna uma mensagem de erro ou uma string vazia
     */
    async validarParametros(parametros) {
        const permiteSelecionarCliente = await this.permissaoController.permiteSelecionarCliente();
        if (parametros.avaliacoes.length === 0) {
            if (permiteSelecionarCliente && !parametros.cliente) {
                return 'É necessário informar o cliente';
            } else if (!parametros.questionario) {
                return 'É necessário informar o questionário';
            } else if (!parametros.quantidade) {
                return 'É necessário informar a quantidade de avaliações a serem comparadas';
            } else if (parametros.quantidade < 1 || parametros.quantidade > 5) {
                return 'A quantidade de avaliações precisa estar entre 1 e 5';
            }
        } else if (parametros.avaliacoes.length > 5) {
            return 'Selecione, no máximo, 5 avaliações';
        }

        return '';
    }

    /**
     * Consulta os dados de uma avaliação no banco de dados
     * @param {Parametros} parametros Dados recebidos como parâmetro para exibição
     * @returns {Array<Avaliacao>} Retorna a lista de avaliações encontradas
     */
    async getAvaliacao(parametros) {
        try {
            let resultado = await this.avaliacaoController.obterResultado({
                idCliente: parametros.cliente,
                idQuestionario: parametros.questionario,
                quantidade: parametros.quantidade,
                avaliacoes: parametros.avaliacoes
            });
            if (resultado.sucesso)
                return resultado.items;
            else
                return [];
        } catch (ex) {
            return [];
        }
    }

    /**
     * Realiza o download do PDF referente ao relatório impresso
     */
    async handleDownloadPDFClick() {
        //Exibe status de processamento
        this.setState({ processando: true });
        //Obtém parâmetros do relatório
        const parametros = this.obterParametros();
        //Obtém conteúdo do arquivo PDF
        let resultado = await this.avaliacaoController.obterResultadoPDF({
            idCliente: parametros.cliente,
            idQuestionario: parametros.questionario,
            quantidade: parametros.quantidade,
            avaliacoes: parametros.avaliacoes
        });
        //const resultado = await this.avaliacaoController.obterResultadoPDF(parametros.cliente, parametros.questionario, parametros.quantidade);
        if (resultado.sucesso){
            //Exibe a solicitação para o usuário salvar o arquivo
            jsFileDownload(resultado.conteudo, 'Resultado avaliacao.pdf', 'application/pdf');
        }
        //Oculta status de processamento
        this.setState({ processando: false });
    }

    /**
     * Trata o evento de click no botão de envio de e-mail
     */
    async handleEnviarEmailClick() {
        //Exibe o dialog de confirmação
        this.setState({ confirmarEnvio: true });
    }

    /**
     * Evento disparado quando o diálogo de confirmação é fechado
     * @param {Boolean} confirm Indica se o usuário confirmou ou não o diálogo
     */
    async handleConfimClose(confirm) {
        //Se o usuário confirmou, envia o e-mail
        if (confirm) {
            //Exibe processamento e oculta o dialog
            this.setState({ processando: true, confirmarEnvio: false });
            //Obtém parâmetros do relatório
            const parametros = this.obterParametros();
            //Requisição para envio de e-mail
            await this.avaliacaoController.enviarEmail({
                idCliente: parametros.cliente,
                idQuestionario: parametros.questionario,
                quantidade: parametros.quantidade,
                avaliacoes: parametros.avaliacoes
            });
            //Oculta o processamento
            this.setState({ processando: false });
        } else //Caso contrário, apenas fecha o diálogo
            this.setState({ confirmarEnvio: false });
    }

    /**
     * Retorna os dados recebidos na URL
     * @returns {Parametros} Dados extraídos da URL
     */
    obterParametros() {
        if (this.props.location && this.props.location.search) {
            const params = new URLSearchParams(this.props.location.search);
            return {
                cliente: converterNumero(params.get('cliente')),
                questionario: converterNumero(params.get('questionario')),
                quantidade: converterNumero(params.get('quantidade')),
                avaliacoes: params.getAll('avaliacoes[]').map(item => converterNumero(item))
            };
        } else {
            return { cliente: 0, questionario: 0, quantidade: 0 };
        }
    }

    render() {
        const { classes, usuario, empresa, permissoes } = this.props;
        const { carregando, erro, processando, confirmarEnvio } = this.state;

        if (carregando) 
            return (
                <Layout onLogout={this.props.onLogout} returnLink="/resultado" usuario={usuario} empresa={empresa} permissoes={permissoes} carregando={carregando} >Carregando resultado...</Layout>
            );

        if (erro)
            return (
                <Layout onLogout={this.props.onLogout} returnLink="/resultado" usuario={usuario} empresa={empresa} permissoes={permissoes} >
                    <VitalizePaper>
                        <Typography>{erro}</Typography>
                    </VitalizePaper>
                </Layout>
            );

        const { avaliacoes } = this.state;
        const permiteEnviarEmail = !!avaliacoes[0].cliente.email && avaliacoes[0].questionario.exibeCliente;

        return (
            <Layout onLogout={this.props.onLogout} returnLink="/resultado" usuario={usuario} empresa={empresa} permissoes={permissoes} >
                <VitalizePaper>
                    <Grid container >
                        <Grid sm container item spacing={1}>
                            <Grid item xs={12} >
                                <Typography id="cliente_nome" variant="h1" className={classes.titulo} >{avaliacoes[0].cliente.nome}</Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <Typography id="questionario_titulo" className={classes.texto} >{avaliacoes[0].questionario.titulo}</Typography>
                            </Grid>
                        </Grid>
                        {
                            permiteEnviarEmail && 
                                <Grid item >
                                    <LoadingButton onClick={this.handleEnviarEmailClick} startIcon={<MailOutlineIcon />} variant="contained" color="primary" loading={processando} >Enviar por e-mail</LoadingButton>
                                </Grid>
                        }
                    </Grid>
                </VitalizePaper>
                <TableContainer component={VitalizePaper}>
                    <Table id="dados_avaliacao" className={classes.tabelaResultado} style={{ minWidth: `calc(150px * ${avaliacoes.length})` }} >
                        <TableBody className={classes.corpoTabela}>
                            <TableRow className={classes.tituloQuestao}>
                                <TableCell colSpan={avaliacoes.length} >
                                    <Typography variant="h3" className={classes.label} >Data execução</Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow id="colunas_resultado">
                                {
                                    avaliacoes.map(avaliacao => (<TableCell key={avaliacao.id} >{avaliacao.dataAlteracao.toLocaleDateString()}</TableCell>))
                                }
                            </TableRow>
                            <TableRow className={classes.tituloQuestao}>
                                <TableCell colSpan={avaliacoes.length} >
                                    <Typography variant="h3" className={classes.label} >Executado por</Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow id="resultado_avaliador">
                                {
                                    avaliacoes.map(avaliacao => (<TableCell key={avaliacao.id} >{avaliacao.avaliador.nome}</TableCell>))
                                }
                            </TableRow>
                            <TableRow className={classes.tituloQuestao}>
                                <TableCell colSpan={avaliacoes.length} >
                                    <Typography variant="h3" className={classes.label} >Idade</Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow id="resultado_idade">
                                {
                                    avaliacoes.map(avaliacao => (<TableCell key={avaliacao.id} >{formatarIdade(avaliacao.cliente.dataNascimento, avaliacao.dataAlteracao)}</TableCell>))
                                }
                            </TableRow>
                        </TableBody>
                        {
                            avaliacoes[0].secoes.map((secao, indiceSecao) => (
                                <ResultadoSecao key={secao.id} secoes={avaliacoes.map(avaliacao => avaliacao.secoes[indiceSecao])} avaliacoes={avaliacoes}  />
                            ))
                        }
                    </Table>
                </TableContainer>
                <LoadingButton component={VitalizeFab} color="primary" variant="extended" type="button" onClick={this.handleDownloadPDFClick} loading={processando} >
                    Download PDF
                </LoadingButton>
                <ConfirmDialog titulo="Deseja enviar o resultado por e-mail para o cliente." open={confirmarEnvio} onClose={this.handleConfimClose} />
            </Layout>
        );
    }
}

ResultadoShowPage.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Informações da URL acessada */
    location: PropTypes.shape({
        search: PropTypes.string
    }),
    /** Estilos do componente */
    classes: PropTypes.object
};

export default withStyles(ResultadoStyle)(ResultadoShowPage);